module.exports = __webpack_public_path__ + "img/production.ef8622c3.png";